import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { PageLayout } from "../../components/page/page-layout";
import { GlobalContext } from "../../context/Provider";
import getAplications from "../../context/actions/aplications/getAplications";
import { DocumentacionMainToolbar } from "../../components/documentacion/documentacion-main-toolbar";
import { EndpointLogin } from "../../components/documentacion/endpoints/endpoint-login";
import { EndpointRefresh } from "../../components/documentacion/endpoints/endpoint-refresh";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { EndpointGenerateForm } from "../../components/documentacion/endpoints/endpoint-generate-form";

const Documentacion = () => {
  const { aplicationsDispatch, aplicationsState } = useContext(GlobalContext);
  const [expandedLogin, setexpandedLogin] = React.useState(false);
  const [expandedRefresh, setExpandedRefresh] = React.useState(false);
  const [expandedForm, setExpandedForm] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const URL_VIDEO_DEMO = "https://www.farmalink.com.ar/share/s/kZyO73--R96cju9_vgfeFQ";
  const URL_VIDEO_SISA = "https://www.farmalink.com.ar/cs/idcplg?IdcService=GET_FILE&dID=164217&dDocName=WCC_PROD-351292";

  const {
    aplications: { data },
  } = aplicationsState;

  useEffect(() => {
    if (data.length === 0) {
      getAplications()(aplicationsDispatch);
    }
  }, [data]);

  const AccordionItem = ({ expanded, onChange, title, children }) => (
    <Accordion expanded={expanded} onChange={onChange} sx={{ my: 2 }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-content"
        id="panel-header"
        sx={{
          background: "#D4F5E6",
          borderRadius: 1,
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <Grid item xs={3} sm={2} md={1}>
            <Box
              sx={{
                background: "#49cc90",
                borderRadius: 1,
                p: 0.5,
                width: isMobile ? "60px" : "auto",
              }}
            >
              <Typography
                sx={{
                  color: "white",
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: isMobile ? "0.8rem" : "0.9rem",
                }}
              >
                POST
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={9} sm={10} md={11}>
            <Typography
              sx={{
                fontSize: isMobile ? "0.9rem" : "1.10rem",
                color: "primary.dark",
                fontWeight: "bold",
              }}
            >
              {title}
            </Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails
        sx={{ padding: isMobile ? "10px 15px" : "10px 30px 30px 30px" }}
      >
        {children}
      </AccordionDetails>
    </Accordion>
  );

  return (
    <PageLayout>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          <Box sx={{ my: 3 }}>
            <DocumentacionMainToolbar />
            <Grid sx={{ my: 2 }}>
              <Typography
                sx={{
                  fontSize: isMobile ? "1rem" : "1.10rem",
                  color: "primary.dark",
                  fontWeight: "700",
                }}
              >
                Base URL
              </Typography>
              <Typography
                sx={{
                  fontSize: isMobile ? "0.9rem" : "1.00rem",
                  color: "#067acc",
                  my: 1,
                  wordBreak: "break-all",
                }}
              >
                {process.env.REACT_APP_API_BASE_URL}
              </Typography>
            </Grid>
            <Grid sx={{ my: 2 }}>
              <Typography
                sx={{ fontSize: "1rem", color: "primary.dark", mb: 2 }}
                variant="h4"
              >
                Video informativo - Demo:{" "}
                <Typography
                  component="a"
                  href={URL_VIDEO_DEMO}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    fontSize: isMobile ? "0.9rem" : "1.00rem",
                    color: "#067acc",
                    textDecoration: "underline",
                    "&:hover": {
                      textDecoration: "none",
                    },
                  }}
                >
                  {URL_VIDEO_DEMO}
                </Typography>
              </Typography>
              <Typography
                sx={{ fontSize: "1rem", color: "primary.dark", mb: 2 }}
                variant="h4"
              >
                Video informativo - Verificación SISA:{" "}
                <Typography
                  component="a"
                  href={URL_VIDEO_SISA}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    fontSize: isMobile ? "0.9rem" : "1.00rem",
                    color: "#067acc",
                    textDecoration: "underline",
                    "&:hover": {
                      textDecoration: "none",
                    },
                  }}
                >
                  {URL_VIDEO_SISA}
                </Typography>
              </Typography>
              <Typography
                sx={{
                  fontSize: isMobile ? "0.9rem" : "1.00rem",
                  color: "primary.dark",
                }}
              >
                Los siguientes API endpoint se utilizan para generar un
                formulario de receta.
              </Typography>
            </Grid>

            <Box>
              <AccordionItem
                expanded={expandedLogin}
                onChange={() => setexpandedLogin(!expandedLogin)}
                title="Login"
              >
                <EndpointLogin />
              </AccordionItem>

              <AccordionItem
                expanded={expandedRefresh}
                onChange={() => setExpandedRefresh(!expandedRefresh)}
                title="Refresh Token"
              >
                <EndpointRefresh />
              </AccordionItem>

              <AccordionItem
                expanded={expandedForm}
                onChange={() => setExpandedForm(!expandedForm)}
                title="Generar link de formulario"
              >
                <EndpointGenerateForm />
              </AccordionItem>
            </Box>
          </Box>
        </Container>
      </Box>
    </PageLayout>
  );
};

export default Documentacion;
